import { DateCustom } from "frontend-core";
import { IUserDTO, User } from "@/models/User";

export class AgentCrossAgreementInfo {
    status: boolean;
    changedDate: DateCustom | null;
    changedUser: User | null;

    constructor(obj: IOsagoCrossAgreementInfoDTO) {
        this.status = obj.status;
        this.changedUser = obj.changedUser !== null ? new User(obj.changedUser) : null;
        this.changedDate = obj.changedDate !== null ? new DateCustom(obj.changedDate) : null;
    }
}

export type IOsagoCrossAgreementInfoDTO = Readonly<{
    "changedDate": string | null;
    "changedUser": IUserDTO | null;
    "oldValue": boolean | null;
    // false - согласование запрещено, true - согласование разрешено
    "status": boolean;
}>
